import { ChatBubbleRoot } from "./chat-bubble";
import { ChatBubbleAttachments } from "./chat-bubble-attachments";
import { ChatBubbleAuthor } from "./chat-bubble-author";
import { ChatBubbleAvatar } from "./chat-bubble-avatar";
import { ChatBubbleBody } from "./chat-bubble-body";
import { ChatBubbleContent } from "./chat-bubble-content";
import { ChatBubbleTimestamp } from "./chat-bubble-timestamp";

/**
 * ChatBubble — single message row in a chat-style thread (DS-048).
 *
 * UI-only molecule. No data shape, no networking, no runtime. Pass real DS
 * atoms (`<Avatar>` via `ChatBubble.Avatar`) and feature components
 * (attachment thumbnails) directly into slots — the molecule owns layout
 * + variant colours only.
 *
 *   <ChatBubble variant="sender">
 *     <ChatBubble.Avatar src={me.avatarUrl} name={me.name} />
 *     <ChatBubble.Body>
 *       <ChatBubble.Author>{me.name}</ChatBubble.Author>
 *       <ChatBubble.Content>Lobby 5 is locked.</ChatBubble.Content>
 *       <ChatBubble.Timestamp>10:41 AM</ChatBubble.Timestamp>
 *     </ChatBubble.Body>
 *   </ChatBubble>
 */
export const ChatBubble = Object.assign(ChatBubbleRoot, {
  Avatar: ChatBubbleAvatar,
  Body: ChatBubbleBody,
  Author: ChatBubbleAuthor,
  Content: ChatBubbleContent,
  Attachments: ChatBubbleAttachments,
  Timestamp: ChatBubbleTimestamp,
});

export type {
  ChatBubbleAttachmentsProps,
  ChatBubbleAuthorProps,
  ChatBubbleAvatarProps,
  ChatBubbleBodyProps,
  ChatBubbleContentProps,
  ChatBubbleContextValue,
  ChatBubbleProps,
  ChatBubbleTimestampProps,
  ChatBubbleVariant,
} from "./types";
